export default {
    bind(el, binding, vnode) {
        el.addEventListener(binding.arg || 'click', e => {
            if (binding.value) {
                e.preventDefault();
                vnode.context.showPopup(binding.value);
            }
        });
    }
}
